import React, { useEffect, useState } from "react";
import { Ticket } from "../../../../../types/types";
import { useNavigate } from "react-router-dom";
import { CheckForm } from "../../../components/CheckForm/CheckForm";
import back from "./image/back.svg";
import "./CheckFormComponent.scss";
import { ScannerComponentsProps } from "../../../../../types/props";
import { checkAuth, getAuthToken } from "../../../../../utils/utils";
import { API_BASE } from "../../../../../config/api";

export const CheckFormComponent = ({
  onSwitch,
  id,
  eventName,
}: ScannerComponentsProps) => {
  const [eventData, setEventData] = useState<Ticket[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [foundTickets, setFoundTickets] = React.useState<Ticket[]>([]);
  const navigate = useNavigate();
  const url = `${API_BASE}`;

  if (!checkAuth()) {
    navigate("/registrationPage");
  }
  const token = getAuthToken();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        const res = await fetch(`${url}/tickets/${id}/`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            authorization: `Bearer ${token}`,
          },
        });
        if (!res.ok) {
          throw new Error("Ошибка загрузки данных");
        }
        const data: Ticket[] = await res.json();
        setEventData(data);
        setFoundTickets(data);
      } catch (error: any) {
        console.error("Ошибка загрузки данных:", error);
        setError(error.message || "Ошибка при загрузке данных");
      }
    };

    fetchData();
  }, [id, token, url]);

  useEffect(() => {
    if (error) {
      alert(error);
      navigate("/");
    }
  }, [error, navigate]);

  return (
    <div className="search-page">
      <div className="search-page__top-wrapper">
        <div className="search-page__title">
          <h2 className="search-page__title__page">Поиск участников </h2>
          <h3 className="search-page__title__event">Событие: {eventName}</h3>
        </div>
        <button className="search-page__btn-back" onClick={onSwitch}>
          <img src={back} alt="back" />
        </button>
      </div>
      <CheckForm
        id={id}
        eventData={eventData}
        foundTickets={foundTickets}
        setFoundTickets={setFoundTickets}
        type_form={"scanner"}
      />
    </div>
  );
};
